<template>
  <form @submit.prevent="newProject">
    <div class="mb-3">
      <label for="projectName">URL</label>
      <input
          type="text"
          name="projectName"
          v-model="formData.url"
          class="form-control"
          id="url"
          :class="{'is-invalid': urlError}"
          @input="clearErrors"
          placeholder="https://example.com"
      >
      <div v-if="urlError" class="invalid-feedback">
        {{ urlError }}
      </div>
    </div>
    <button
        type="submit"
        class="btn btn-primary"
        :disabled="!isFormValid || loading"
    >
      <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
      Создать
    </button>
  </form>
</template>

<script setup>
import {ref, computed} from "vue";
import {useApiPingStore} from '@/store/api-ping'

const apiPingStore = useApiPingStore()
const loading = ref(false)
const formData = ref({
  url: "",
})
const urlError = ref("")

// Функция для валидации URL
function isValidUrl(url) {
  if (!url) return false

  try {
    const urlObj = new URL(url)
    const hostname = urlObj.hostname

    // Разрешаем localhost для тестирования (убрали запрет)
    if (hostname === 'localhost') {
      return true // или false, в зависимости от ваших потребностей
    }

    const domainParts = hostname.split('.')

    // Домен должен иметь хотя бы 2 части
    if (domainParts.length < 2) {
      return false
    }

    const tld = domainParts[domainParts.length - 1]

    // Более гибкая проверка TLD:
    // - Разрешаем Punycode (начинается с xn--)
    // - Разрешаем обычные TLD (2+ символа)
    // - Разрешаем некоторые специальные TLD
    if (!tld || tld.length < 2) {
      return false
    }

    // Проверяем, что все части домена не пустые
    for (const part of domainParts) {
      if (!part.trim()) {
        return false
      }
    }

    return true
  } catch {
    return false
  }
}

// Функция для проверки URL формата
function validateUrl(url) {
  if (!url.trim()) {
    return "URL обязателен для заполнения"
  }

  // Проверяем, содержит ли URL протокол
  if (!url.startsWith('https://')) {
    return "URL должен начинаться с https://"
  }

  // Проверяем валидность URL
  if (!isValidUrl(url)) {
    return "Введите корректный URL с правильным доменом (например: https://example.com)"
  }

  return ""
}

// Очистка ошибок при вводе
function clearErrors() {
  urlError.value = ""
}

// Вычисляемое свойство для проверки валидности формы
const isFormValid = computed(() => {
  const url = formData.value.url.trim()
  return url && !validateUrl(url)
})

async function newProject() {
  // Проверяем валидность перед отправкой
  if (!isFormValid.value) {
    urlError.value = validateUrl(formData.value.url) || "Неверный URL"
    return
  }

  loading.value = true

  try {
    await apiPingStore.create(formData.value)
    // Опционально: сброс формы после успешного создания
    formData.value.url = ""
    urlError.value = ""
    location.reload()
  } catch (error) {
    console.error("Ошибка при создании проекта:", error)
    urlError.value = "Произошла ошибка при создании проекта. Попробуйте еще раз."
  } finally {
    loading.value = false
  }
}
</script>